;(function($) {
  "use strict"
  $(function() {
    if ($(".navigation").length > 0) {
      let headerHeight = $(".header").outerHeight();
      $(".navigation__link").on("click", function () {
        $(this).closest(".navigation").find(".navigation__link").removeClass("navigation__link_active")
        $(this).addClass("navigation__link_active")
        $("html, body").animate({
          scrollTop: $($.attr(this, 'href')).offset().top - headerHeight
      }, 400);
      });
    }
  })
})(jQuery)
